import React from "react";

const modalities = [
    {
        n: "I.",
        title: "EMDR",
        href: "/emdr",
        subtitle: "Eye Movement Desensitization & Reprocessing",
        body: "For when fear and earlier experiences still quietly shape your decisions. EMDR helps the brain process what remained unfinished, so memories no longer carry the same emotional weight.",
    },
    {
        n: "II.",
        title: "Brainspotting",
        href: "/brainspotting",
        subtitle: "A precise, body-aware approach",
        body: "Brainspotting reaches the places that talk therapy cannot easily touch — accessing the body's own capacity to release and reorganize what trauma left behind.",
    },
    {
        n: "III.",
        title: "ACT",
        href: "/act",
        subtitle: "Acceptance & Commitment Therapy",
        body: "Fear often appears the moment we move toward the life we want. ACT helps you build psychological flexibility — and step forward with intention, even when fear is in the room.",
    },
    {
        n: "IV.",
        title: "DBT-informed",
        href: "/dbt",
        subtitle: "Dialectical Behavior Therapy skills",
        body: "Practical tools for navigating intense emotions, tolerating distress, and staying grounded in the difficult moments — so deeper work becomes possible.",
    },
];

export default function Modalities() {
    return (
        <section id="modalities" data-testid="modalities-section" className="py-28 lg:py-40" style={{ background: "#FAFAF8" }}>
            <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
                <div className="max-w-2xl" data-reveal>
                    <span className="editorial-eyebrow">Areas of Expertise</span>
                    <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-charcoal">
                        Four <em className="italic text-gold">careful</em> ways of doing this work.
                    </h2>
                </div>

                <div className="mt-20 grid md:grid-cols-2 gap-px" style={{ background: "#E2DDD8" }} data-testid="modalities-grid">
                    {modalities.map((m) => (
                        <div
                            key={m.title}
                            data-testid={`modality-${m.title.toLowerCase().replace(/\s|-/g, "")}`}
                            className="p-10 lg:p-14 group transition-all duration-500 block hover:-translate-y-1"
                            style={{ background: "#FAFAF8" }}
                            data-reveal
                        >
                            <a href={m.href} className="block" data-testid={`modality-${m.title.toLowerCase().replace(/\s|-/g, "")}-link`}>
                                <div className="flex items-start justify-between mb-6">
                                    <span className="font-serif text-2xl text-gold">{m.n}</span>
                                    <span className="font-serif text-gold text-xl leading-none transition-transform duration-700 group-hover:rotate-90">✦</span>
                                </div>
                                <h3 className="font-serif text-4xl text-charcoal mb-2">{m.title}</h3>
                                <p className="text-[12px] tracking-[0.22em] uppercase text-gold mb-8">{m.subtitle}</p>
                                <div className="h-px w-12 mb-8" style={{ background: "#8A9E85" }} />
                                <p className="text-charcoal-soft leading-[1.85] text-base">{m.body}</p>
                                <div className="mt-6 text-[11px] tracking-[0.24em] uppercase text-gold opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                    Read more →
                                </div>
                            </a>

                            {/* Card I only — quiet secondary note pointing to the Intensives page */}
                            {m.title === "EMDR" && (
                                <>
                                    <div className="mt-8 h-px w-full" style={{ background: "#E2DDD8" }} />
                                    <a
                                        href="/emdr-intensive"
                                        data-testid="modality-emdr-intensive-link"
                                        className="mt-4 inline-block font-serif italic text-gold text-base hover:opacity-80 transition-opacity duration-300"
                                    >
                                        Also offering: EMDR Intensives →
                                    </a>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
